module.exports = __webpack_public_path__ + "media/promo/courses/images/new-fd39c3b47eaedce13906d5e904122eb5.png";